import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NOB from '../../../constants/language-strings';
import NavigationButton from '../../../components/Buttons/NavigationButton/navigation-button';
import { FOLLOW_UP_CUSTOMER_URL, NEW_WORK_ORDER_URL } from '../../../constants/paths';
import { icons } from 'theme/icons';
function WorkOrderCompletionNavigationButtons({ createdFollowUpForm: { created, workOrderId }, currentWorkOrderId = 0, createFollowUpIsFetching, createWorkOrderIsFetching, createdWorkOrderdId, }) {
    return (_jsxs("div", { className: "work_log-buttons", children: [_jsx(NavigationButton, { URL: FOLLOW_UP_CUSTOMER_URL(currentWorkOrderId), title: created && currentWorkOrderId === workOrderId
                    ? NOB.WORK_LOG.FOLLOW_UP_CREATED
                    : NOB.WORK_LOG.FOLLOW_UP, isFetching: createFollowUpIsFetching, disabled: created && currentWorkOrderId === workOrderId, rightIcon: created && currentWorkOrderId === workOrderId ? icons.checkmark : null }), _jsx(NavigationButton, { URL: NEW_WORK_ORDER_URL(currentWorkOrderId), title: createdWorkOrderdId === currentWorkOrderId
                    ? NOB.WORK_LOG.WORK_ORDER_CREATED
                    : NOB.WORK_LOG.CREATE_NEW_WORK_ORDER, rightIcon: createdWorkOrderdId === currentWorkOrderId ? icons.checkmark : null, disabled: createdWorkOrderdId === currentWorkOrderId, isFetching: createWorkOrderIsFetching })] }));
}
WorkOrderCompletionNavigationButtons.propTypes = {
    currentWorkOrderId: PropTypes.number,
    createdFollowUpForm: PropTypes.objectOf(PropTypes.any).isRequired,
    createFollowUpIsFetching: PropTypes.bool.isRequired,
    createWorkOrderIsFetching: PropTypes.bool.isRequired,
    createdWorkOrderdId: PropTypes.number,
};
const mapStateToProps = state => ({
    createFollowUpIsFetching: state.zendesk.followUpForm.isFetching,
    createdFollowUpForm: state.zendesk.followUpForm,
    createWorkOrderIsFetching: state.createWorkOrder.isFetching,
    role: state.authentication.role,
    createdWorkOrderdId: state.createWorkOrder.workOrderId,
});
export default connect(mapStateToProps)(WorkOrderCompletionNavigationButtons);
